import React = require('react')

// A component that can be added to a (page with a) form to start invisible recaptcha.
// Call grecaptcha.execute() on submit to evaluate the user, which might prompt a puzzle.
// after a succesful validation, the callback function is executed
type RecaptchaProps = {
  callback: () => void
}
export class Recaptcha extends React.Component<RecaptchaProps, {}> {
  componentDidMount() {
    const callback = this.props.callback

    grecaptcha.ready(function () {
      grecaptcha.render("recaptcha-container", {
        callback: async (token: string) => {
          const response = await fetch(`api/v1/recaptcha/validate?token=${token}`)
          const json: { success: boolean } = await response.json()
          if (json.success) callback()
        },
        sitekey: recaptcha_sitekey,
        size: 'invisible'
      })
    })
  }
  render() {
    return <div id="recaptcha-container"></div>
  }
}
